import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Lottie from "react-lottie";
import animationData from "./animations/animation.json";
import Text from "./text/Text";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { currencyImages, logoWithName } from "./images";
import { useSelector } from "react-redux";
import { btc, poweredBy, sats } from "./messages";
import { getDisplayCurrencySymbol } from "./constants";

function CommonSuccessPage({ isFromBrowser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { showBtcAmount } = useSelector((state) => state.common);

  const { completionHeading, amount, currency, subMessage } = {
    ...location?.state,
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    setTimeout(() => {
      if (isFromBrowser) {
        navigate("/wallet");
      } else {
        navigate("/dashboard");
      }
    }, 5000);
  }, []);

  return (
    <Box
      className="paid-payment-wrapper"
      sx={{
        backgroundColor:
          currency === sats || currency === btc ? "#FEF6EB" : "#ffffff",
      }}
    >
      <CloseIcon
        sx={{
          color: "#848B9E",
          height: "24px",
          width: "24px",
          cursor: "pointer",
        }}
        className="close-icon"
        onClick={() => navigate("/dashboard")}
      />
      <Lottie options={defaultOptions} height="110px" width="110px" />
      <Box
        className="paid-payment-detail"
        width={isFromBrowser ? "450px" : "335px"}
        textAlign="center"
      >
        <Text size={20} className="default-text txt-uppercase" font="regular">
          {completionHeading}
        </Text>
        <Text size={44} className="default-text txt-uppercase" font="bold">
          {getDisplayCurrencySymbol(currency, showBtcAmount)}
          {amount}
        </Text>

        <Text size={24} className="txt-uppercase grey-text" font="semibold">
          {currency}
        </Text>

        {subMessage && (
          <Text
            size={16}
            className="default-text"
            font="regular"
            sx={{ wordBreak: "break-word" }}
          >
            {subMessage}
          </Text>
        )}
        <Box
          display="flex"
          position="absolute"
          alignItems="center"
          bottom="25px"
        >
          <Text
            size={!isFromBrowser ? 12 : 14}
            className="default-text"
            font="semibold"
          >
            {poweredBy}
          </Text>
          <img
            src={logoWithName}
            alt="logo"
            style={{
              marginLeft: "12px",
              ...(!isFromBrowser && { height: "20px" }),
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default CommonSuccessPage;
